module.exports = __webpack_public_path__ + "static/media/google-play-btn.efeaf1c2.png";